var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "social social--dir-" + _vm.direction }, [
    _vm.showCaption
      ? _c("span", { staticClass: "social__title" }, [
          _vm._v(_vm._s(_vm.text.title)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "social__link-container" },
      _vm._l(_vm.twoLinks, function (link) {
        return _c(
          "a",
          {
            key: link.icon,
            class: "social__link social__link--" + link.icon,
            attrs: { target: "_blank", href: link.link },
          },
          [
            _c("z-icon", {
              attrs: { name: link.icon, width: "100%", height: "100%" },
            }),
            _vm._v(" "),
            _vm.showLabels
              ? _c("span", { staticClass: "social__name" }, [
                  _vm._v(_vm._s(link.name)),
                ])
              : _vm._e(),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }